<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 7L9 12L14 17" stroke="#1B262C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
